export const environment = {
  production: false,
  apiBaseUrl: 'https://ist-gsic-ewrs-webapi.azurewebsites.net/api/',
  clientId: 'b6ad8d84-7d13-438d-8d5e-6196e73e44be',
  appInsightsKey: '106f457f-3a92-4510-9cb5-f1a1b3061665',
  redirectUri: 'https://dev.ewrs.gov.on.ca/auth',
  impersonationUrl: 'api://srv_d_auth_ewrs/user_impersonation',
  version: '20261021.1',
  faviconPath: 'assets/images/favicon-dev.svg',
  e2eToken: '{e2eJwtToken}',
};
